import { LockKeyhole } from "lucide-react"
import { useTranslation } from "react-i18next"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export function DecisionPlaceholder() {
  const { t } = useTranslation("intake")

  return (
    <Card className="border-dashed">
      <CardHeader>
        <div className="text-muted-foreground text-[11px] font-semibold uppercase tracking-wide">
          {t("decisionPlaceholder.kicker")}
        </div>
        <CardTitle className="text-lg">
          {t("decisionPlaceholder.title")}
        </CardTitle>
        <CardDescription>{t("decisionPlaceholder.subtitle")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-muted-foreground/70 flex items-center justify-center gap-2 py-6 text-xs">
          <LockKeyhole className="size-4" />
          <span>{t("decisionPlaceholder.subtitle")}</span>
        </div>
      </CardContent>
    </Card>
  )
}
